import React from 'react';

import { createTheme, ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { AuthProvider } from './auth';
import { UniversitiesProvider } from './universities';

const theme = createTheme({
  typography: {
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeightBold: 700,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
});

export function AppProvider({ children }) {
  return (
    <AuthProvider>
      <UniversitiesProvider>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>{children}</ThemeProvider>
        </StyledEngineProvider>
      </UniversitiesProvider>
    </AuthProvider>
  );
}
